module.exports = __webpack_public_path__ + "static/media/Koobot_Processed_02A.e9db0a40.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/Koobot_Processed_02A.mp3
// module id = 113
// module chunks = 0